import React from "react";
import ExtendedSelect from './select';
import Autosuggest from './suggest_field';
import { styled } from '@mui/material/styles';
import { inputFontSize } from '../theme';

interface FastSelectProps {
    input?: {
        value?: any;
        onChange?: (...args: any[]) => void;
        [key: string]: any;
    };
    style?: React.CSSProperties;
    disabled?: boolean;
    [key: string]: any;
}

const StyledSelect = styled(ExtendedSelect)<any>(({ theme }) => ({
  '& .select-input': {
    padding: '6px 0 7px',
    height: '1.175em !important'
  },
  '& .MuiTypography-root.singleValue': {
    fontSize: inputFontSize,
  }
}));

const FastSelect = (props: FastSelectProps) => {
    let {input, style, disabled, ...otherProps} = props;
    if(disabled){
        return <Autosuggest disabled style={style} input={input} {...otherProps}/>;
    }
    return <StyledSelect inline={true} value={input.value} onChange={input.onChange} {...otherProps} style={{placeSelf: 'inherit', ...style}}/>;
};

export default FastSelect;
